var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.proTypedialogVisible,
            title: _vm.title,
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.proTypedialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "120px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "景区名称", prop: "scenicName" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isEdit,
                      placeholder: "请输入景区名称",
                    },
                    model: {
                      value: _vm.form.scenicName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "scenicName", $$v)
                      },
                      expression: "form.scenicName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isEdit,
                      placeholder: "请输入详细地址",
                    },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "开放时间", prop: "adjust" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "is-range": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "HH:mm",
                      "value-format": "HH:mm:ss",
                    },
                    model: {
                      value: _vm.form.adjust,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "adjust", $$v)
                      },
                      expression: "form.adjust",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "官方电话", prop: "officialPhone" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isEdit,
                      placeholder: "请输入官方电话",
                    },
                    model: {
                      value: _vm.form.officialPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "officialPhone", $$v)
                      },
                      expression: "form.officialPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "缩略图", prop: "image" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox acea-row",
                      on: {
                        click: function ($event) {
                          return _vm.modalPicTap("1")
                        },
                      },
                    },
                    [
                      _vm.form.image
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.form.image } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "请上传图片比例为2:1大小不超过300KB格式为png/jpg/jpeg/webp的文件"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "景区详情图：", prop: "sliderImages" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _vm._l(_vm.form.sliderImages, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "pictrue",
                            attrs: { draggable: "true" },
                            on: {
                              dragstart: function ($event) {
                                return _vm.handleDragStart($event, item)
                              },
                              dragover: function ($event) {
                                $event.preventDefault()
                                return _vm.handleDragOver($event, item)
                              },
                              dragenter: function ($event) {
                                return _vm.handleDragEnter($event, item)
                              },
                              dragend: function ($event) {
                                return _vm.handleDragEnd($event, item)
                              },
                            },
                          },
                          [
                            _c("img", { attrs: { src: item } }),
                            !_vm.isEdit
                              ? _c("i", {
                                  staticClass: "el-icon-error  btndel",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemove(index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm.form.sliderImages.length < 10
                        ? _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("2")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "建议尺寸：800*800px，上传小于500kb的图片；最多可上传10张图片，拖动可调整顺序"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "景区简介" } },
                [
                  _c("Tinymce", {
                    key: 0,
                    model: {
                      value: _vm.form.blurb,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "blurb",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.blurb",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isEdit,
                  expression: "!isEdit",
                },
              ],
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.proTypedialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }